import { Provider } from "@redotech/redo-order-common/provider";
import { redoRecommendedProductSchema } from "@redotech/redo-product-common/redo-recommended-product-schema";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getRecommendedProductsByProvider = {
  name: "getRecommendedProductsByProvider" as const,
  input: z.object({
    provider: createEnum(Provider),
    excludedVariantIds: z.array(z.string()),
    excludedParentProductIds: z.array(z.string()),
    numRecommendations: z.number(),
    customer: z.object({ email: z.string().nullish() }),
    /** Commerce Cloud-specific */
    ccSiteId: z.string().optional(),
    recommendedProductFilterId: z.string().optional(),
    /** Secondary filter used to fill remaining slots when the primary filter
     * yields fewer than numRecommendations products after filtering. */
    fallbackRecommendedProductFilterId: z.string().optional(),
    /** Product IDs for provider recommendations strategy (e.g., from order line items) */
    productIds: z.array(z.string()).optional(),
    /** ISO 3166-1 alpha-2 country code (e.g. "US", "GB"). Used by Shopify
     * storefront `@inContext` to return prices in the customer's presentment
     * currency. */
    countryCode: z.string().optional(),
    orderId: z.string().optional(),
  }),
  output: z.object({ products: z.array(redoRecommendedProductSchema) }),
};
